import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { HttpClient } from '@angular/common/http';
import { forkJoin, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);

  /** Main translation file, merged with the one of the October 2026 design (`anc.*` keys). */
  getTranslation(lang: string) {
    return forkJoin([
      this.http.get<Translation>(`/i18n/${lang}.json`),
      this.http.get<Translation>(`/i18n/anc/${lang}.json`),
    ]).pipe(map(([main, anc]) => ({ ...main, ...anc })));
  }
}
